import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

function SFRCropFertilizerRecommendation({ selectedCrop, selectedBlend, cropRecommendation }) {
  const { t } = useTranslation();
  return (
    <>
      {cropRecommendation && (
        <>
          <Text style={styles.sectionTitle}>{t("soil.cropBasedFertilizerRecommendation")}</Text>
          <Text style={styles.recommendationItem}>
            <Text style={styles.nutrientLabel}>{t("common.crop")}: </Text>
            {t(`crops.${selectedCrop}`)}
          </Text>

          <Text style={styles.recommendationItem}>
            <Text style={styles.nutrientLabel}>{t("common.fertilizerBlend")}: </Text>
            {selectedBlend}
          </Text>

          <View style={styles.cropResult}>
            <Text style={styles.cropResultText}>{cropRecommendation}</Text>
          </View>
        </>
      )}
    </>
  );
}

export default SFRCropFertilizerRecommendation;

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 8,
  },
  recommendationItem: {
    fontSize: 10,
    color: "#374151",
    marginBottom: 4,
    lineHeight: 1.5,
  },
  nutrientLabel: {
    fontWeight: "bold",
  },
  cropResult: {
    marginTop: 8,
    padding: 10,
    border: "1px solid #bbf7d0",
    borderRadius: 6,
    backgroundColor: "#f0fdf4",
  },
  cropResultText: {
    fontSize: 10,
    color: "#374151",
  },
});
